import { Pipe, PipeTransform } from '@angular/core';
import { CompanySubtype, CompanySubtypeLabels } from '@models/companies/company-enums';

@Pipe({
  standalone: true,
  name: 'companySubtype'
})
export class CompanySubtypePipe implements PipeTransform {
  transform(value: CompanySubtype | undefined): string {
    if(value != undefined)
      return CompanySubtypeLabels[value];
    return '-';
  }
}
